/* eslint-disable camelcase */
import api from "../../../services/service_pos";
import Swal from "sweetalert2";
import apiCus from "../../../services/service_customer";
import moment from "moment";
import apiCalendar from "../../../services/service_calendar";
import apiCenter from "../../../services/service_undefined";
import apiCenterV2 from "../../../services/service_undefined_v2";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  components: {
    VueBootstrapTypeahead
  },
  props: ["host", "type_payment"],
  data() {
    return {
      payment_amount_cash: "0",
      payment_amount_transfer: "0",
      isDisabled: false,
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      hostshift: "",
      customer_data: [],
      customer: "",
      description: "",
      calendar_time: moment(new Date()),
      calendar_description: "",
      auto_day: 0,
      status_gentime: false
    };
  },
  methods: {
    moment,
    changeDay(val) {
      this.auto_day = val;
      this.calendar_time = moment(new Date()).add(val, "days");
    },
    checkAmount() {
      if (this.payment_amount_cash === "") {
        this.payment_amount_cash = 0;
      }
      if (this.payment_amount_transfer === "") {
        this.payment_amount_transfer = 0;
      }
    },
    PaymentProcessQR() {
      // if (parseFloat(this.payment_amount) === parseFloat((this.$store.state.order_data.item_amount - this.$store.state.order_data.discount_amount))) {
      //   if (this.$store.state.order_data.id) {
      //     this.$store.state.order_data.bank_amount = parseFloat(this.payment_amount)
      //     this.$store.state.order_data.cash_amount = 0
      //     this.checkUpdateOut()
      //   } else {
      //     this.$store.state.order_data.bank_amount = parseFloat(this.payment_amount)
      //     this.$store.state.order_data.cash_amount = 0
      //     this.checkOut()
      //   }
      // } else {
      //   Swal.fire(
      //     'ชำระเงินไม่สมบูรณ์',
      //     'ยอดรับชำระต้องเท่ากับยอดค้างชำระ',
      //     'warning'
      //   )
      //   setTimeout(() => {
      //     $('#PaymentModal').modal('show')
      //   }, 500)
      // }
    },
    PaymentProcessCash() {
      console.log(
        parseFloat(this.payment_amount_transfer),
        parseFloat(
          this.$store.state.order_data.item_amount -
            this.$store.state.order_data.discount_amount
        )
      );
      if (
        parseFloat(this.payment_amount_transfer) <=
        parseFloat(
          this.$store.state.order_data.item_amount -
            this.$store.state.order_data.discount_amount
        )
      ) {
        if (this.$store.state.order_data.id) {
          console.log("case1");
          this.$store.state.order_data.cash_amount = parseFloat(
            this.payment_amount_cash
          );
          this.$store.state.order_data.bank_amount = parseFloat(
            this.payment_amount_transfer
          );
          this.checkUpdateOut();
        } else {
          console.log("case2");
          this.$store.state.order_data.cash_amount = parseFloat(
            this.payment_amount_cash
          );
          this.$store.state.order_data.bank_amount = parseFloat(
            this.payment_amount_transfer
          );
          this.checkOut();
        }
      } else {
        Swal.fire(
          "ชำระเงินไม่สมบูรณ์",
          "ยอดรับชำระต้องเท่ากับยอดค้างชำระ",
          "warning"
        );
        setTimeout(() => {
          $("#PaymentModal").modal("show");
        }, 500);
      }
    },
    checkUpdateOut() {
      console.log("payment Cash 98");
      // eslint-disable-next-line camelcase
      let change_amount =
        parseFloat(this.payment_amount_cash) +
        parseFloat(this.payment_amount_transfer) -
        (this.$store.state.order_data.item_amount -
          this.$store.state.order_data.discount_amount);
      $("#PaymentModal").modal("hide");
      if (parseFloat(change_amount) >= 0) {
        this.$store.commit("Loading");
        this.$store.state.order_data.host_code = this.host.host_code;
        this.$store.state.order_data.shift_id = parseFloat(this.host.id);
        this.$store.state.order_data.bill_type = 0;
        const ar = this.customer.split(":");
        if (ar.length > 1) {
          this.$store.state.order_data.ar_code = ar[0];
        }
        this.$store.state.order_data.cust_description = this.customer;
        console.log(this.$store.state.order_data.holding_status);
        if (this.$store.state.order_data.holding_status === 0) {
          this.decreaseItemInAPI();
        }
        api.UpdateSale(
          this.REST_URL,
          this.$store.state.order_data,
          this.header,
          result => {
            if (result.response === "success") {
              if (
                this.calendar_description ||
                (this.status_gentime === true && this.customer)
              ) {
                if (!this.calendar_description) {
                  this.calendar_description = "-";
                }
                this.addCalendar({
                  id: 0,
                  title:
                    "H" +
                    this.auto_day +
                    "(" +
                    this.customer +
                    ") " +
                    this.dateFormatDMY(new Date()) +
                    " " +
                    this.calendar_description,
                  // title: '(' + this.customer + ') ' + this.calendar_description,
                  start: this.calendar_time
                });
              }
              this.status_gentime = false;
              this.$store.commit("clearOrderPayment");
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
              this.openCashBox(this.host);
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
              if (parseFloat(change_amount) >= 1) {
                Swal.fire({
                  title: "ชำระเงินสำเร็จ",
                  html:
                    '<p class="swal-change-amount">กรุณาทอนเงินจำนวน <span class="swal-change-amount-num">' +
                    this.numberFormat(change_amount) +
                    "</span> บาท</p>",
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "ปิดหน้าต่าง"
                });
              } else {
                Swal.fire({
                  title: "ชำระเงินสำเร็จ",
                  text:
                    result.data && result.data.doc_no
                      ? "เลขที่ " + result.data.doc_no + " ทำรายการเรียบร้อยแล้ว"
                      : "ทำรายการเรียบร้อยแล้ว",
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "ปิดหน้าต่าง"
                });
              }
            } else {
              this.$notification["warning"]({
                message: "สร้างใบเสร็จไม่ได้",
                description: result.message
              });
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
            }
            this.$store.commit("Loading");
          },
          error => {
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            this.$store.commit("Loading");
          }
        );
      } else {
        Swal.fire("ชำระเงินไม่สมบูรณ์", "ยอดรับชำระน้อยเกินไป", "warning");
        setTimeout(() => {
          $("#PaymentModal").modal("show");
        }, 500);
      }
    },
    decreaseItemInAPI(branchName) {
      let summery_weight = 0.0;
      this.$store.state.order_data.sub.map(e => {
        if (e.item_data.group_code === "60") {
          summery_weight = summery_weight + e.item_data.weight * e.qty;
        }
      });

      apiCenterV2.decreaseRemain(
        {
          stockDate: new Date(),
          stock_qty: summery_weight,
          createdBy: "admin"
        },
        this.header,
        results => {
          if (results.data.isStatus) {
            console.log(results.data);
          } else {
          }
        },
        errors => {
          this.$notification["warning"]({
            message: "ไม่สามารถทำการลดจำนวนสินค้าข้าวหม่าได้",
            description: errors.data.message
          });
        }
      );
    },
    checkOut() {
      // console.log("payment Cash 248")
      let change_amount =
        parseFloat(this.payment_amount_cash) +
        parseFloat(this.payment_amount_transfer) -
        (this.$store.state.order_data.item_amount -
          this.$store.state.order_data.discount_amount);
      $("#PaymentModal").modal("hide");
      if (parseFloat(change_amount) >= 0) {
        this.$store.commit("Loading");
        this.$store.state.order_data.host_code = this.host.host_code;
        this.$store.state.order_data.shift_id = parseFloat(this.host.id);
        const ar = this.customer.split(":");
        if (ar.length > 1) {
          this.$store.state.order_data.ar_code = ar[0];
        }
        this.$store.state.order_data.cust_description = this.customer;
        this.$store.state.order_data.description = this.description;
        if (this.customer !== "") {
          this.$store.state.order_data.calendar_time = moment(
            this.calendar_time
          ).format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.$store.state.order_data.calendar_time = "";
        }
        this.$store.state.order_data.calendar_description = this.calendar_description;
        // alert(JSON.stringify(this.$store.state.order_data))
        // let summery_weight = 0.00
        // this.$store.state.order_data.sub.map(e => {
        //   summery_weight = summery_weight + e.item_data.weight
        // })
        // console.log(summery_weight)
        // console.log(this.$store.state.order_data.holding_status)
        if (this.$store.state.order_data.holding_status === 0) {
          this.decreaseItemInAPI();
        }
        let product = this.$store.state.order_data.sub;

        apiCenterV2.updateStock(
          {
            product: product
          },
          this.header,
          results => {},
          errors => {
            this.$notification["warning"]({
              message: "ไม่สามารถทำการลดจำนวนสินค้าข้าวหม่าได้",
              description: errors.data.message
            });
          }
        );

        // console.log(this.$store.state.order_data);
        api.addSale(
          this.REST_URL,
          this.$store.state.order_data,
          this.header,
          result => {
            if (result.response === "success") {
              if (
                this.calendar_description ||
                (this.status_gentime === true && this.customer)
              ) {
                if (!this.calendar_description) {
                  this.calendar_description = "-";
                }
                this.addCalendar({
                  id: 0,
                  title:
                    "H" +
                    this.auto_day +
                    "(" +
                    this.customer +
                    ") " +
                    this.dateFormatDMY(new Date()) +
                    " " +
                    this.calendar_description,
                  // title: '(' + this.customer + ') ' + this.calendar_description,
                  start: this.calendar_time
                });
              }
              this.$store.commit("clearOrderPayment");
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
              this.status_gentime = false;
              this.openCashBox(this.host);
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
              if (parseFloat(change_amount) >= 1) {
                Swal.fire({
                  title: "ชำระเงินสำเร็จ",
                  html:
                    '<p class="swal-change-amount">กรุณาทอนเงินจำนวน <span class="swal-change-amount-num">' +
                    this.numberFormat(change_amount) +
                    "</span> บาท</p>",
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "ปิดหน้าต่าง"
                });
              } else {
                Swal.fire({
                  title: "ชำระเงินสำเร็จ",
                  text:
                    result.data && result.data.doc_no
                      ? "เลขที่ " + result.data.doc_no + " ทำรายการเรียบร้อยแล้ว"
                      : "ทำรายการเรียบร้อยแล้ว",
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "ปิดหน้าต่าง"
                });
              }
            } else {
              this.$notification["warning"]({
                message: "สร้างใบเสร็จไม่ได้",
                description: result.message
              });
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
            }
            this.$store.commit("Loading");
          },
          error => {
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            this.$store.commit("Loading");
            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });
          }
        );
      } else {
        Swal.fire("ชำระเงินไม่สมบูรณ์", "ยอดรับชำระน้อยเกินไป", "warning");
        setTimeout(() => {
          $("#PaymentModal").modal("show");
        }, 500);
      }
    },
    printBill(docNo) {
      this.$store.commit("Loading");
      var obj = {
        printer_port: this.host.printer_port,
        doc_no: docNo
      };
      api.printBill(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === "success") {
            this.$notification["success"]({
              message: "พิมพ์ใบเสร็จสำเร็จ",
              description: result.message
            });
            this.openCashBox(this.host);
            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });
            this.$store.commit("Loading");
          } else {
            this.$notification["warning"]({
              message: "พิมพ์ใบเสร็จไม่ได้",
              description: result.message
            });
            this.$store.commit("Loading");
            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });
          }
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          this.$store.commit("Loading");
          $("body").on("hidden.bs.modal", ".modal", function() {
            console.clear();
            $(this).removeData("bs.modal");
          });
        }
      );
    },
    checkShift(val) {
      if (this.$store.state.order_data.multiple) {
        if (
          parseFloat(this.$store.state.order_data.item_amount) <=
            parseFloat(this.payment_amount_cash) ||
          parseFloat(this.$store.state.order_data.item_amount) <=
            parseFloat(this.payment_amount_transfer)
        ) {
          const config = JSON.parse(localStorage.getItem("config"));
          if (config.length > 0) {
            // apiCenter.updateHoldBill(
            //   {
            //     branchName: config[0].branch_name.replaceAll(" ", ""),
            //     data: this.$store.state.order_data,
            //     cash:
            //       this.payment_amount_cash === undefined
            //         ? 0
            //         : this.payment_amount_cash,
            //     credit:
            //       this.payment_amount_transfer === undefined
            //         ? 0
            //         : this.payment_amount_transfer,
            //     create_by: "admin"
            //   },
            //   results => {
            //     $("#PaymentModal").modal("hide");
            //     this.$store.commit("clearOrderPayment");
            //     Swal.fire({
            //       title: "ชำระเงินสำเร็จ",
            //       text: "ท่านต้องการพิมพ์ใบเสร็จหรือไม่ ?",
            //       icon: "success",
            //       showCancelButton: true,
            //       confirmButtonColor: "#3085d6",
            //       cancelButtonColor: "#d33",
            //       confirmButtonText: "พิมพ์",
            //       cancelButtonText: "ไม่พิมพ์"
            //     }).then(res => {
            //       if (res.value) {
            //         for (var i = 0; i < results.data.doc_no.length; i++) {
            //           this.printBill(results.data.doc_no[i]);
            //         }
            //         $("body").on("hidden.bs.modal", ".modal", function() {
            //           $(this).removeData("bs.modal");
            //         });
            //       } else {
            //         this.openCashBox(this.host);
            //         $("body").on("hidden.bs.modal", ".modal", function() {
            //           $(this).removeData("bs.modal");
            //         });
            //       }
            //     });
            //   },
            //   errors => {}
            // );
          }
        } else {
          Swal.fire({
            title: "ชำระเงินไม่สำเร็จ",
            text: "กรณีเลือกชำระหลายรายการ จะต้องจ่ายเงินเต็มจำนวนเท่านั้น",
            icon: "warning"
          });
        }
      } else {
        api.checkOpenShift(
          this.REST_URL,
          this.header,
          { host_code: val },
          result => {
            if (result.response === "success") {
              if (result.data.is_closed === 1 || result.data.id === 0) {
                // this.$notification['error']({
                //   message: 'กะปัจจุบันถูกปิดอยู่',
                //   description: 'กรุณาเปิดกะและทำรายการใหม่'
                // })
                // location.reload()
                alert("ไม่พบกะปัจจุบัน");
                this.$router.push("/");
              } else {
                this.host.id = parseFloat(result.data.id);
                this.PaymentProcessCash();
              }
            } else {
              alert(result.message);
              this.$router.push("/");
            }
          },
          error => {
            alert("Error checkShift" + JSON.stringify(error));
            this.$router.push("/");
          }
        );
      }
    },
    getCustomer() {
      // this.$store.commit('Loading')
      let body = {
        keyword: "",
        limit: 1000000,
        status: 1
      };
      apiCus.listAll(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === "success") {
            this.customer_data = [];
            result.data.forEach(val => {
              this.customer_data.push(val["code"] + ": " + val["name"]);
              if (
                this.$store.state.order_data.holding_status === 1 &&
                this.$store.state.order_data.bill_type === 0
              ) {
                if (this.$store.state.order_data.ar_code === val["code"]) {
                  this.customer = val["code"] + ": " + val["name"];
                  if (this.$refs.cusAuto) {
                    this.$refs.cusAuto.inputValue = this.customer;
                  }
                }
              } else {
                this.customer = "";
                if (this.$refs.cusAuto) {
                  this.$refs.cusAuto.inputValue = "";
                }
              }
            });
          } else {
            this.$notification["warning"]({
              message: "ดึงข้อมูลลูกหนี้",
              description: result.message
            });
          }
          // this.$store.commit('Loading')
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
        }
      );
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf("day");
    },
    disabledDateTime() {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56]
      };
    },
    addKeyCash(str) {
      console.log(str);
      if (
        this.payment_amount_cash.length < 7 ||
        this.payment_amount_cash.length === undefined
      ) {
        if (
          this.payment_amount_cash === "0" ||
          this.payment_amount_cash === 0
        ) {
          this.payment_amount_cash = "";
        } else {
          this.payment_amount_cash = this.payment_amount_cash.toString();
        }
        this.payment_amount_cash += str;
      }
    },
    removeKeyCash() {
      if (this.payment_amount_cash.length > 0) {
        this.payment_amount_cash = this.payment_amount_cash.substring(
          this.payment_amount_cash.length - 1,
          0
        );
        if (this.payment_amount_cash.length === 0) {
          this.payment_amount_cash = "0";
        }
      }
    },
    addKeyBank(str) {
      if (
        this.payment_amount_transfer.length < 7 ||
        this.payment_amount_transfer.length === undefined
      ) {
        if (
          this.payment_amount_transfer === "0" ||
          this.payment_amount_cash === 0
        ) {
          this.payment_amount_transfer = "";
        } else {
          this.payment_amount_transfer = this.payment_amount_transfer.toString();
        }
        this.payment_amount_transfer += str;
      }
    },
    removeKeyBank() {
      if (this.payment_amount_transfer.length > 0) {
        this.payment_amount_transfer = this.payment_amount_transfer.substring(
          this.payment_amount_transfer.length - 1,
          0
        );
        if (this.payment_amount_transfer.length === 0) {
          this.payment_amount_transfer = "0";
        }
      }
    },
    addCalendar(data) {
      if (data.title !== "") {
        const obj = {
          id: data.id,
          title: data.title,
          start: moment(data.start).format("YYYY-MM-DD HH:mm:ss"),
          color: "yellow",
          all_day: false
        };
        if (obj.id === 0) {
          obj.status = 0;
        } else {
          obj.status = 1;
        }
        apiCalendar.new(
          this.REST_URL,
          {
            headers: {
              "Access-Token": sessionStorage.token
            }
          },
          obj,
          result => {
            if (result.response === "success") {
              this.$notification["success"]({
                message: "ข้อมูลการนัดหมาย",
                description: "จัดการข้อมูลการนัดหมายสำเร็จ!!"
              });
            } else {
              this.$notification["warning"]({
                message: "จัดการข้อมูลปฎิทิน",
                description: result.message
              });
            }
          },
          error => {
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          }
        );
      } else {
        this.$notification["warning"]({
          message: "เพิ่มข้อมูลปฎิทิน",
          description: "ไม่มีข้อมูล"
        });
      }
    }
  },
  mounted() {
    this.isDisabled = true;
    this.getCustomer();
    $("#PaymentModal").on(
      "hidden.bs.modal",
      function() {
        this.payment_amount_cash = "0";
        this.payment_amount_transfer = "0";
        this.customer = "";
        this.description = "";
        this.calendar_time = moment(new Date());
        this.calendar_description = "";
        this.auto_day = 0;
        $(this).removeData("bs.modal");
      }.bind(this)
    );
    $("#PaymentModal").on(
      "show.bs.modal",
      function() {
        this.getCustomer();
        setTimeout(() => {
          if (this.type_payment === 0) {
            this.isDisabled = false;
            this.description = this.$store.state.order_data.description;
          } else {
            this.isDisabled = false;
            this.payment_amount_cash = parseFloat(
              this.$store.state.order_data.item_amount
            );
            this.description = this.$store.state.order_data.description;
            // console.log(this.customer)
            if (this.customer === "") {
              this.$refs.cusAuto.inputValue = JSON.parse(
                sessionStorage.config
              )[0].def_cust_code;
              this.customer = JSON.parse(
                sessionStorage.config
              )[0].def_cust_code;
            }
            // this.$store.state.order_data.ar_code = JSON.parse(sessionStorage.config)[0].def_cust_code
          }
        }, 800);
      }.bind(this)
    );
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/paymentcash.js